import { render, staticRenderFns } from "./NotificationCompanyDepartmentMemberCreated.vue?vue&type=template&id=74b40a66&scoped=true&lang=pug&"
import script from "./NotificationCompanyDepartmentMemberCreated.vue?vue&type=script&lang=js&"
export * from "./NotificationCompanyDepartmentMemberCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b40a66",
  null
  
)

export default component.exports